<template>
  <div style="background-color: #F5F7FA;height:350px;">

    <div style="padding: 10px">
      <span>APP是否报警：</span>
      <el-select v-model="tag" placeholder="请选择是否报警" style="width:300px">
        <el-option
            v-for="item in tagValue"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" @click="appAlert" style="margin-left:10px">编辑</el-button>
    </div>

    <div style="padding: 10px">
      <span>记步是否开启：</span>
      <el-select v-model="tagStep" placeholder="选择是否报警" style="width:300px">
        <el-option
            v-for="item in tagStepValue"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" @click="editStep" style="margin-left:10px">编辑</el-button>
    </div>

    <div style="padding: 10px">
      <span>心率上传间隔：</span>
      <el-select v-model="spanTimeHeart" placeholder="请选择是间隔时间" style="width:300px">
        <el-option
            v-for="item in spanTimeHearts"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" @click="editHeart" style="margin-left:10px">编辑</el-button>
    </div>

    <div style="padding: 10px">
      <span>位置上传间隔：</span>
      <el-select v-model="spanTimePosition" placeholder="请选择是间隔时间" style="width:300px">
        <el-option
            v-for="item in spanTimePositions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" @click="editPosition" style="margin-left:10px">编辑</el-button>
    </div>

  </div>

</template>

<script>



import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "PageForDevice",
  data() {
    return {
      userDeviceCode: '',

      tagStep:'',
      tagStepValue: [{
        value: 0, label: '关闭'
      }, {
        value: 1, label: '开启'
      }],

      tag:'',
      tagValue: [{
        value: 0, label: '不提醒'
      }, {
        value: 1, label: '提醒'
      }],

      spanTimeHeart:'',
      spanTimeHearts: [
        {value: '360', label: '360秒'},
        {value: '540', label: '540秒'},
        {value: '720', label: '720秒'},
        {value: '900', label: '900秒'},
        {value: '9000', label: '9000秒'},
        {value: '12000', label: '12000秒'},
        {value: '28800', label: '28800秒'},
      ],

      spanTimePosition:'',
      spanTimePositions: [
        {value: '360', label: '360秒'},
        {value: '540', label: '540秒'},
        {value: '720', label: '720秒'},
        {value: '900', label: '900秒'},
        {value: '9000', label: '9000秒'},
        {value: '12000', label: '12000秒'},
        {value: '28800', label: '28800秒'},
      ],


    }
  },
  components: {

  },

  methods: {
    init(userDeviceCode) {
      this.userDeviceCode = userDeviceCode;


      this.tag = '';
      this.spanTimeHeart = '';
      this.spanTimePosition = '';


      this.getWeiLanInfoDevice();

    },
    closeSelf() {
      this.$emit("closeWeiLanAlarmShow");
    },

    getWeiLanInfoDevice(){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "Positioning/WeiLanInfoDevice",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          userDeviceCode:this.userDeviceCode,
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              //console.log(response.data.data)

              //this.tag=response.data.data.deviceXiaodouFence.alertSwitch;

              this.tag=response.data.data.deviceXiaodou.weiLanAlert;
              this.tagStep = response.data.data.deviceXiaodou.tagStep;
              this.spanTimeHeart=response.data.data.deviceXiaodou.spanTimeHeart;
              this.spanTimePosition=response.data.data.deviceXiaodou.spanTimePosition;

            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },

    appAlert(){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "Positioning/EditAPPIsAlert",//EditIsAlert
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userDeviceCode: this.userDeviceCode,
          alertSwitch:this.tag
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              console.log(response.data.data)
              this.$emit("closeWeiLanAlarmShow");
              this.$message({type: 'success', message:'编辑成功！'});
            } else if (response.data.error === 1) {
              this.$message({type: 'warning', message: response.data.message});
            }
          }
      )
    },

    editStep(){

      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "Positioning/EditTagStep",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userDeviceCode: this.userDeviceCode,
          tagStep:this.tagStep
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              //console.log(response.data.data)
              //this.$emit("closeWeiLanAlarmShow");
              this.$message({type: 'success', message:'编辑成功！'});
            } else if (response.data.error === 1) {
              this.$message({type: 'warning', message: response.data.message});
            }
          }
      )

    },

    editHeart(){

      if(this.spanTimeHeart == ''){
        this.$message.info("请选择时间");
        return;
      }

      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "Positioning/EditSpanTimeForHeart",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          userDeviceCode: this.userDeviceCode,
          spanTime:this.spanTimeHeart,
          type:'heart',
        }
      }).then((response) => {
            console.log(response.data.data)
            if (response.data.error === 0) {
              this.$emit("closeWeiLanAlarmShow");
              this.$message({type: 'success', message:'编辑成功！'});
            } else if (response.data.error === 1) {
              this.$message({type: 'warning', message: response.data.message});
            }
          }
      )
    },

    editPosition(){

      if(this.spanTimePosition == ''){
        this.$message.info("请选择时间");
        return;
      }

      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "Positioning/EditSpanTimeForPosition",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          userDeviceCode: this.userDeviceCode,
          spanTime:this.spanTimePosition,
          //type:'heart',
        }
      }).then((response) => {
            console.log(response.data.data)
            if (response.data.error === 0) {
              this.$emit("closeWeiLanAlarmShow");
              this.$message({type: 'success', message:'编辑成功！'});
            } else if (response.data.error === 1) {
              this.$message({type: 'warning', message: response.data.message});
            }
          }
      )

    },

  },

}


</script>
